class CustomHeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById('js_searchForm')
    this.keywordInput = document.getElementById('js_searchKeywordInput');
    this.category = document.getElementById('js_searchCategory');
    this.submit = document.getElementById('js_searchSubmit');
    this.setupEventListeners();
  }

  setupEventListeners() {
    // フォームの送信イベントを監視
    this.form.addEventListener('submit', this.onSearchSubmit.bind(this));
    this.submit.addEventListener('click', this.onSearchSubmit.bind(this));
  }

  onSearchSubmit(event) {
    event.preventDefault(); // フォームの通常の送信動作を防ぐ

    if (!this.keywordInput) return;

    const searchValue = this.keywordInput.value.trim();

    const categoryValue = this.category.value

    this.updateSearchFormAction(searchValue, categoryValue);
  }

  updateSearchFormAction(query, filter) {
    if (!this.keywordInput) return;

    if (this.form) {
      let searchAction = new URL(this.form.action || window.location.href);

      // 既存のパラメータを整理
      searchAction.searchParams.delete('q');
      searchAction.searchParams.delete('sort_by');

      // クエリセット（空ならアスタリスク検索）
      searchAction.searchParams.set('q', query !== '' ? query : '*');

      // 並び替え：価格の高い順
      searchAction.searchParams.set('sort_by', 'relevance');

      // 検索結果ページへリダイレクト
      window.location.href = `${searchAction.toString()}&${filter}`;
    }
  }
}

customElements.define('tk-search-form', CustomHeaderSearch);

class CustomMainSearch extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById('js_mainSearchForm');
    this.keywordInput = document.getElementById('js_searchKeywordMainInput');
    this.reset = document.getElementById('js_searchKeywordReset');
    this.submit = document.getElementById('js_searchSubmit');
    this.setupEventListeners();
    this.currentUrl = new URL(window.location.href);
    this.sortBy = this.currentUrl.searchParams.get('sort_by');
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onSearchSubmit.bind(this));
    this.submit.addEventListener('click', this.onSearchSubmit.bind(this));
    this.reset.addEventListener('click', this.resetInput.bind(this));
  }

  resetInput(event) {
    this.keywordInput.value = ''
  }

  onSearchSubmit(event) {
    event.preventDefault(); // 通常の送信をキャンセル

    if (!this.keywordInput) return;

    const searchValue = this.keywordInput.value.trim();

    // merchandiseフィルターをURLから取得
    const merchandiseFilterKey = 'filter.p.m.custom.merchandise';
    const currentMerchandise = this.currentUrl.searchParams.get(merchandiseFilterKey);

    // フィルターパラメータを生成
    let filterParams = '';
    if (currentMerchandise) {
      filterParams += `${merchandiseFilterKey}=${encodeURIComponent(currentMerchandise)}`;
    }

    this.updateSearchFormAction(searchValue, filterParams);
  }

  updateSearchFormAction(query, filter) {
    if (!this.keywordInput || !this.form) return;

    let searchAction = new URL(this.form.action || window.location.href);

    // 既存のパラメータを整理
    searchAction.searchParams.delete('q');
    searchAction.searchParams.delete('sort_by');

    // クエリセット（空ならアスタリスク検索）
    searchAction.searchParams.set('q', query !== '' ? query : '*');

    // 並び替え：価格の高い順
    if (this.sortBy) {
      searchAction.searchParams.set('sort_by', this.sortBy);
    } else {
      searchAction.searchParams.set('sort_by', 'relevance');
    }

    // 検索結果ページへリダイレクト
    let finalUrl = searchAction.toString();
    if (filter) {
      finalUrl += `&${filter}`;
    }

    window.location.href = finalUrl;
  }
}

customElements.define('tk-main-search', CustomMainSearch);
